import { Identifier } from '@okletsplay/core';
import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';
import { GameStatisticsEntity } from 'app/interfaces/entity';
import { apiRequestCall } from 'app/services/api';
import { ApiResource } from 'app/services/api/enums';
import { cancelationSubscribe } from 'app/services/api/utils';
import { entityStoreStatus } from 'app/utils/store/entity-store-status';
import { GameStatisticsStoreStatus } from 'modules/game-statistics/enums';
import { GameStatisticsState } from 'modules/game-statistics/interfaces';

export const getGameStatistics = createAsyncThunk(
  `${EntityStoreName.GameStatistics}/getGameStatistics`,
  (id: Identifier, { signal }): Promise<GameStatisticsEntity> => {
    const cancelToken = cancelationSubscribe(signal);

    return apiRequestCall<GameStatisticsEntity>({
      params: {
        method: 'GET',
        resource: ApiResource.GameStatistics,
        urlPrefix: id,
        cancelToken,
      },
    });
  }
);

export const registerReducers = (builder: ActionReducerMapBuilder<GameStatisticsState>): void => {
  builder
    .addCase(getGameStatistics.pending, (state, action) => {
      entityStoreStatus.addRequestId(
        state,
        GameStatisticsStoreStatus.Loading,
        action.meta.requestId
      );
    })
    .addCase(getGameStatistics.fulfilled, (state, action) => {
      state.entity = { ...state.entity, ...action.payload };
      entityStoreStatus.removeRequestId(
        state,
        GameStatisticsStoreStatus.Loading,
        action.meta.requestId
      );
    })
    .addCase(getGameStatistics.rejected, (state, action) => {
      state.entity = null;
      entityStoreStatus.removeRequestId(
        state,
        GameStatisticsStoreStatus.Loading,
        action.meta.requestId
      );
    });
};
